/* eslint-disable @typescript-eslint/no-explicit-any */
/*
 * Base class for all components. Sets specific default values.
 */

import { ChangeDetectionStrategy, Component } from '@angular/core';
import { AppPages } from '@app/app.pages';
import { environment } from '@environment/environment';
import { Environment } from '@interfaces/environment.interface';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-base-component',
  changeDetection: ChangeDetectionStrategy.Eager,
  template: ''
})
export abstract class BaseComponent {
  // declaration of fields
  public appPages = AppPages;
  public environment: Environment = environment;
  public data: Observable<any> | null = null;
}
